import Vue from 'vue';
import Vuex from 'vuex';
import helpers from './mixins/helpers'
Vue.use(Vuex);
import { store } from './store';

if(document.getElementById('lector')) {
    let lector = new Vue({
        mixins: [helpers],
        el:'#lector',
        data:{
            store,
            archive:{},
            schedule:{},
            lector: null,
            load: false,
            page: 1,
            pageCount: 0,
            os: store.state.os,
        },
        mounted:function () {
          this.fetchLector();
          this.fetchSchedule();
          this.fetchArchive();

        },
        computed: {
            // a computed getter
            votes: function () {
                return this.lector.rating.votes + ' ' + this.decOfNum(this.lector.rating.votes, ['голоса', 'голосов', 'голосов']);

            },
            lectionsPassed: function () {

                return this.lector.rating.lection_count + ' ' + this.decOfNum(this.lector.rating.lection_count, ['вебинара', 'вебинарах', 'вебинарах']);

            },
            userVotes: function () {
                return this.lector.rating.user_votes + ' ' + this.decOfNum(this.lector.rating.user_votes, ['врача', 'врачей', 'врачей']);
            },
            lectorThumb: function () {

                return this.lector.photo.thumb + '?v=' + this.lector.updated;

            }
        },
        methods:{
            fetchLector: function () {
                var self = this;

                this.load = true;

                try {
                    $.ajax({
                        url: '/api/v1/lector/view',
                        dataType: "json",
                        data: {id:lectorId},
                        success: function (data) {
                            self.lector = data.item;
                        },
                        fail: function () {

                            throw new Error('Ошибка получении данных');

                        }
                    });

                } catch (e) {

                    console.error(e);

                }
            },
            classRating: function (rating) {

                return {
                    'best': (rating > 4 ),
                    'good': (rating > 3 && rating <= 4),
                    'normal': (rating > 2 && rating <= 3),
                    'poorly': (rating > 1 && rating <= 2),
                    'bad': rating <= 1
                };
            },
            fetchSchedule:function(){
                var self = this;

                $.ajax({
                    url: '/api/v1/lection',
                    dataType: "json",
                    data: {'schedule':1,lector_id:lectorId},
                    success: function (data) {

                        self.schedule = data;
                    },
                    fail: function () {

                        throw new Error('Ошибка получении данных');

                    }
                });
            },
            fetchArchive:function(append){
                var self = this;
                this.load = true;

                try {

                    var data = {'schedule':0,lector_id:lectorId};

                    $.extend(data, {page: this.page});

                    $.ajax({
                        url: '/api/v1/lection',
                        dataType: "json",
                        data: data,
                        success: function (data) {
                            if (append === true) {
                                $.each(data.items, function (i, item) {

                                    self.archive.items.push(item);

                                });

                            } else {

                                self.archive = data;
                                self.pageCount = data._meta.pageCount;
                                self.page = 1;

                            }
                            self.load = false;

                        },
                        fail: function () {

                            throw new Error('Ошибка получении данных');

                        }
                    });

                } catch (e) {

                    console.error(e);

                }
            },
            getDelayTime: function (time) {
                let currentDate = Date.now();
                let startDay = new Date(time * 1000 - currentDate);

                let returnStr = '';

                if(startDay.getUTCHours()  > 0) {
                    returnStr += startDay.getUTCHours() + ' ч. ';
                }

                if(startDay.getMinutes() > 0){
                    returnStr +=  startDay.getMinutes()  + ' мин. ';
                }

                return returnStr;
            }
        },
        filters:{
            plural:function(number,titles){
                let cases = [2, 0, 1, 1, 1, 2];

                return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];

            }
        },
    });

}